define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.removeSessionStorage = exports.getSessionStorage = exports.setSessionStorage = exports.removeLocalStorage = exports.getLocalStorage = exports.setLocalStorage = void 0;
    var setLocalStorage = function (key, obj) {
        if (localStorage) {
            try {
                localStorage.setItem(key, JSON.stringify(obj));
            }
            catch (error) {
                console.log('set local storage eroor', error);
            }
        }
    };
    exports.setLocalStorage = setLocalStorage;
    var getLocalStorage = function (key) {
        var jsonStr = '';
        if (localStorage) {
            try {
                jsonStr = localStorage.getItem(key);
                if (!jsonStr) {
                    return jsonStr;
                }
                jsonStr = jsonStr.toString();
                if (typeof jsonStr === 'undefined') {
                    jsonStr = undefined;
                }
                else {
                    jsonStr = JSON.parse(jsonStr);
                }
            }
            catch (error) {
                console.log('get local storage error', error);
            }
        }
        return jsonStr;
    };
    exports.getLocalStorage = getLocalStorage;
    var removeLocalStorage = function (key) {
        if (localStorage) {
            localStorage.removeItem(key);
        }
    };
    exports.removeLocalStorage = removeLocalStorage;
    var setSessionStorage = function (key, obj) {
        if (sessionStorage) {
            try {
                sessionStorage.setItem(key, JSON.stringify(obj));
            }
            catch (error) {
                console.log('set sessionStorage eroor', error);
            }
        }
    };
    exports.setSessionStorage = setSessionStorage;
    var getSessionStorage = function (key) {
        var jsonStr = '';
        if (sessionStorage) {
            try {
                jsonStr = sessionStorage.getItem(key);
                if (!jsonStr) {
                    return jsonStr;
                }
                jsonStr = jsonStr.toString();
                if (typeof jsonStr === 'undefined') {
                    jsonStr = undefined;
                }
                else {
                    jsonStr = JSON.parse(jsonStr);
                }
            }
            catch (error) {
                console.log('get sessionStorage error', error);
            }
        }
        return jsonStr;
    };
    exports.getSessionStorage = getSessionStorage;
    var removeSessionStorage = function (key) {
        if (sessionStorage) {
            sessionStorage.removeItem(key);
        }
    };
    exports.removeSessionStorage = removeSessionStorage;
});
//# sourceMappingURL=UtilsLocalStorage.js.map